import { IGetChecklistServicosByIdObraDropDownUseCase } from "../../../presentation/useCases/read/get_checklist_servicos_by_id_obra_drop_down_use_case";
import { ChecklistServicoDropDown } from "../../models/checklist_servico_dropdown";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetChecklistServicosByIdObraDropDownUseCase
 */

export class GetChecklistServicosByIdObraDropDownUseCase implements IGetChecklistServicosByIdObraDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getChecklistServicosByIdObraDropDown(
    idObra?: number,
    idObraAreaChecklist?: number,
    tipoServico?: number,
  ): Promise<ChecklistServicoDropDown[]> {
    if (idObra === undefined) throw new Error("Id de obra invalido!");
    if (idObraAreaChecklist === undefined) throw new Error("Id de area invalido!");
    return await this.repository.getChecklistServicosByIdObraDropDown(
      idObra, idObraAreaChecklist, tipoServico);
  }
}
